import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { useBuildType, useGetFilterParams, useTypeDisplayedSpinner } from 'src/hooks';
import { getCurrentSpinner } from 'src/store/spinner/selectors';
import { ListOfKeysFilterAllData } from 'src/typings/filter';
import { usePolygonsSwitch } from 'src/components/ViewSpinner/components/PolygonsSwitch/hooks/usePolygonsSwitch';
import { useGetFilteredIds } from './useGetFilteredIds';
import { usePolygonConfig } from './usePolygonConfig';

export const useFilledPolygons = () => {
  const { getIdsByType } = useGetFilteredIds();
  const { selectedParams } = useGetFilterParams();
  const { globalPolygonConfig } = usePolygonConfig();
  const currentSpinner = useSelector(getCurrentSpinner);
  const { showPolygons } = usePolygonsSwitch();
  const { isCrossTable } = useBuildType();
  const { getSelectedViewId } = useTypeDisplayedSpinner();

  const handleIsSelectedFillColor = useCallback((name: string, nameId: string) => {
    const value = getIdsByType(name);
    const highlightAllPolygons = isEmpty(value) && globalPolygonConfig?.is_pre_highlight_polygons_in_module;
    const isHouseSpinnerWithoutFilter = selectedParams.some((item) => item.name === ListOfKeysFilterAllData.placementHouse)
      && selectedParams.length === 1
      && currentSpinner?.name !== 'complex';
    if (!isCrossTable && (!selectedParams.length || isHouseSpinnerWithoutFilter) && showPolygons) return true;
    if (isHouseSpinnerWithoutFilter && !globalPolygonConfig?.is_pre_highlight_polygons_in_module && !isCrossTable) {
      return false;
    }

    return isCrossTable ? (value?.includes(nameId) || highlightAllPolygons) : ((value?.includes(nameId) || highlightAllPolygons) && showPolygons);
  }, [currentSpinner, selectedParams, getIdsByType, showPolygons, getSelectedViewId]);

  return {
    handleIsSelectedFillColor,
  };
};
